import React from 'react'
import type { DefaultTypedEditorState } from '@payloadcms/richtext-lexical'

const FORMAT = {
  BOLD: 1,
  ITALIC: 2,
} as const

type RenderOptions = {
  paragraphClassName?: string
}

export const renderSimpleLexicalContent = (
  content?: DefaultTypedEditorState | null,
  options: RenderOptions = {},
) => {
  if (!content || typeof content !== 'object' || !('root' in content)) {
    return null
  }

  const root = (content as any).root
  if (!root || !Array.isArray(root.children)) {
    return null
  }

  const { paragraphClassName } = options

  const paragraphs = root.children
    .filter((node: any) => node && typeof node === 'object' && node.type === 'paragraph')
    .map((paragraph: any, paragraphIndex: number) => {
      const children = Array.isArray(paragraph.children) ? paragraph.children : []

      if (children.length === 0) {
        return null
      }

      return (
        <p className={paragraphClassName} key={`lexical-paragraph-${paragraphIndex}`}>
          {children.map((child: any, childIndex: number) => {
            if (child?.type === 'linebreak') {
              return <br key={`lexical-paragraph-${paragraphIndex}-br-${childIndex}`} />
            }

            if (child?.type !== 'text' || typeof child.text !== 'string') {
              return null
            }

            const format = child.format ?? 0
            let node: React.ReactNode = child.text

            if (format & FORMAT.ITALIC) {
              node = <em>{node}</em>
            }

            if (format & FORMAT.BOLD) {
              node = <strong>{node}</strong>
            }

            return (
              <React.Fragment key={`lexical-paragraph-${paragraphIndex}-text-${childIndex}`}>
                {node}
              </React.Fragment>
            )
          })}
        </p>
      )
    })
    .filter(Boolean)

  if (paragraphs.length === 0) {
    return null
  }

  return paragraphs
}
